"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShockwaveAbilityHandler = exports.ShockwaveActorAbilityFactory = exports.ShockwaveAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const core_1 = require("../../core/effects/core");
const Duration_1 = require("../../core/Duration");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class ShockwaveAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Shockwave;
        this.__typeName = "Shockwave";
    }
}
exports.ShockwaveAbilityArgs = ShockwaveAbilityArgs;
let ShockwaveActorAbilityFactory = class ShockwaveActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Shockwave", "AllEnemies", 2);
    }
};
ShockwaveActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Shockwave")
], ShockwaveActorAbilityFactory);
exports.ShockwaveActorAbilityFactory = ShockwaveActorAbilityFactory;
let ShockwaveAbilityHandler = class ShockwaveAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        container.applyJumpingProjectileAttackWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "ranged",
            attackerId: ability.invokerId,
            targetIds: container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies),
            projectileType: "MultiElementBlast",
            projectilePath: "line",
            toApply: [
                AbilityDamage_1.AbilityDamage.Focus("Nature", 50)
            ],
            onHit: (sequence, _attack, _damages, targetId) => {
                container.applyDebuff({
                    sequence,
                    attackerId: ability.invokerId,
                    targetId,
                    duration: Duration_1.Duration.Ticks(16),
                    effect: new core_1.PoisonedEffectArgs("Focus", 10),
                });
            },
        });
    }
};
ShockwaveAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Shockwave)
], ShockwaveAbilityHandler);
exports.ShockwaveAbilityHandler = ShockwaveAbilityHandler;
